@use '../../scss/abstracts/variables' as *;

.skeleton {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 260px;
  background: #ede6d8;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  border-radius: inherit;

  &.dark {
    background: #1e1912;

    .gridLines {
      background-image:
        linear-gradient(to right, rgba(201, 164, 77, 0.08) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(201, 164, 77, 0.08) 1px, transparent 1px);
    }

    .topography {
      opacity: 0.08;
      stroke: #c9a44d;
    }

    .loadingBadge {
      color: #e7ddc7;
      background: rgba(30, 25, 18, 0.85);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(191, 138, 46, 0.3);
    }

    .mockBtn {
      background: rgba(30, 25, 18, 0.85);
      color: #bf8a2e;
      border: 1px solid rgba(191, 138, 46, 0.2);
    }

    .shimmer {
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(201, 164, 77, 0.08) 50%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
}

.shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.45) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: translateX(-100%);
  animation: shimmerWave 2.2s infinite ease-in-out;
  pointer-events: none;
  z-index: 1;
}

@keyframes shimmerWave {
  100% {
    transform: translateX(100%);
  }
}

.gridLines {
  position: absolute;
  inset: 0;
  opacity: 0.4;
  pointer-events: none;
  background-size: 36px 36px;
  background-image:
    linear-gradient(to right, rgba(140, 120, 95, 0.2) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(140, 120, 95, 0.2) 1px, transparent 1px);
}

.topography {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.12;
  pointer-events: none;
  stroke: #735d3d;
  fill: none;
}

.pinTarget {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
}

.pulseWrapper {
  position: relative;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pulseRing {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #bf8a2e;
  opacity: 0;
  animation: radarPulse 2.4s infinite cubic-bezier(0.2, 0.8, 0.4, 1);
}

.pulseRingDelay {
  animation-delay: 0.8s;
}

@keyframes radarPulse {
  0% {
    transform: scale(0.3);
    opacity: 0.9;
  }
  100% {
    transform: scale(1.7);
    opacity: 0;
  }
}

.markerIcon {
  position: relative;
  z-index: 3;
  color: #bf8a2e;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.25));
  animation: bouncePin 2.4s infinite ease-in-out;
}

@keyframes bouncePin {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.loadingBadge {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6a573b;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(6px);
  padding: 0.45rem 1.1rem;
  border-radius: 24px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

.badgeDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #bf8a2e;
  animation: pulseDot 1.4s infinite ease-in-out;
}

@keyframes pulseDot {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.6);
    opacity: 0.4;
  }
}

.mockControls {
  position: absolute;
  top: 1.4rem;
  right: 1.4rem;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.mockBtn {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(4px);
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7a6b57;
  font-size: 1.2rem;
  font-weight: 600;
}
